import { axiosProvider } from '@/app/core/axios';
import { TnCApiResponse, EnumTnCType, TnCError } from '@ssar-app/domain';

export const get = (type: string, subCode: string): Promise<TnCApiResponse> => {
  const validTypes: string[] = Object.values(EnumTnCType);
  return new Promise((resolve, reject) => {
    const typeIndex = validTypes.indexOf(type);
    if (typeIndex >= 0) {
      axiosProvider.apiClient
        .get<TnCApiResponse>(
          `/tnc?type=${encodeURIComponent(
            validTypes[typeIndex],
          )}&subCode=${encodeURIComponent(subCode)}`,
        )
        .then((response) => {
          if (response) {
            const { data } = response;
            resolve(data);
          }
        })
        .catch((error) => {
          reject(error);
        });
    } else {
      reject(
        new TnCError(
          'Not a valid Terms & Condition. Please contact our help center.',
          500,
          `TnC Type mismatch: ${type}`,
        ),
      );
    }
  });
};
